import { createAsyncThunk } from "@reduxjs/toolkit"
import { claimVoucherByMerchantService } from "../../services/voucher.service"

export const claimVoucherByMerchant = createAsyncThunk(
  "/claimVoucherByMerchant",
  async (payload, { rejectWithValue }) => {
    return await claimVoucherByMerchantService(payload, rejectWithValue)
  }
)
